<template>
  <div>
    <section>
      <div class="mb10">
        <span class="rp-grey-label">没有合适简历：</span>
        <div :class="files.length>0?'morandi-btn-outline':'morandi-btn'" style="font-size:12px;padding: 3px;margin-right:10px" @click="() => $refs.upload.visible(true)">上传简历</div>
        <peixun type="4" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
      </div>
      <div class="mb10">
        <span class="rp-grey-label">人选附件：</span>
        <span style="font-size:12px;color:#e67720">
          {{files.length > 0?'选择一个附件作为推荐报告制作参考，没有符合的附件请上传':'候选人还没有附件，请上传一份附件作为推荐报告制作参考'}}
        </span>
      </div>
      <div v-show="autoSelect" style="font-size:12px;color:#e67720;line-height:30px">根据您操作的文件，已经默认为您选择人选附件</div>
      <div class="rp-attach-table">
        <el-row class="rp-table-head">
          <el-col :span="3">类型</el-col>
          <el-col :span="9">文件名</el-col>
          <el-col :span="3">上传时间</el-col>
          <el-col :span="6">上传人</el-col>
          <el-col :span="3">预览</el-col>
        </el-row>
        <div class="rp-attachs" style="max-height: calc(100vh - 410px);">
          <div v-for="(item, index) in files" :key="index" @click="selectFile(item)" :id="item.md5">
            <el-row class="rp-attach" :class="{'rp-attach-active':selected === item.md5}">
              <el-col :span="3">{{ item.type }}</el-col>
              <el-col :span="9">{{ item.originalname }}</el-col>
              <el-col :span="3">{{ dateFormat(item.updatedAt, 'yyyy-mm-dd') }}</el-col>
              <el-col :span="6">{{ Array.isArray(item.uploader) && item.uploader.length >0 ?item.uploader.join('、'):'无' }}</el-col>
              <el-col :span="3">
                <span class="rp-a-link" @click.stop="preview(item)">查看预览</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </section>
    <UploadDialog ref="upload" :on-success="uploadSuccess" type="原始简历" title="简历上传" />
  </div>
</template>

<script>
const dateFormat = require('dateformat')

export default {
  data() {
    return {
      selected: undefined,
      files: [],
      autoSelect: false,
      radish: {}
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
  },
  methods: {
    init({ radish, defaultSelectedFile}) {
      // console.log('radish', radish)
      if (!radish) return this.$messge.error('缺少人选数据')
      if (!radish.attachments) {
        this.files = []
      }
      this.radish = radish
      try {
        const attach = JSON.parse(JSON.stringify(radish.attachments))
        if (!attach || !Array.isArray(attach)) {
          this.files = []
          return
        }
        this.files = attach.sort((a, b) => {
          if (a.type == '原始简历' && b.type != '原始简历') {
            return -1;
          } else if (a.type != '原始简历' && b.type == '原始简历') {
            return 1
          } else {
            return b.createdAt && a.createdAt < b.createdAt ? 1 : -1
          }
        })
      } catch (err) {
        this.files = []
      }
      if (defaultSelectedFile) {
        this.selectFile(defaultSelectedFile)
        this.$nextTick(()=>{
          document.getElementById(defaultSelectedFile.md5).scrollIntoView()
        })
        this.autoSelect = true
      }
    },
    selectFile(item) {
      this.selected = item.md5
      this.autoSelect = false
      this.$emit('selectItem', item)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible(false)
      const attachment = Object.assign(response[0], { rid: this.radish._id })
      try {
        await app.service('radish').addAttachment(attachment)
        this.files.unshift(attachment)
        this.selectFile(attachment)
        this.$emit('next')
      } catch (e) {
        console.error(e)
      }
    },
    async preview(file) {
      console.log(file)
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>

<style>
.rp-attach-table {
  border:1px solid #eee;
  border-radius:4px;
  padding:20px;
  font-size: 12px;

}
.rp-table-head {
  font-weight: bold;
  background-color: #f5f6f8;
}
.rp-attachs {
  overflow-y: auto;
  min-height: 100px;
  color: #999;
}
.rp-attach {
  border-bottom: 1px solid #f5f6f8;
  cursor: pointer;
}
.rp-attach-table .el-col {
  padding: 10px;
}
.rp-attach:hover, .rp-attach-active {
  background: #aec7db;
  color: #fff;
}
.rp-grey-label {
  color: #999;
  margin-right: 10px;
  font-size: 12px;
}
</style>
